module.exports = __webpack_public_path__ + "static/logo-7910000006a5cac32650395717bb030f.png";